import { render } from "./AlertMessage.vue?vue&type=template&id=6bdf1935&scoped=true&ts=true"
import script from "./AlertMessage.vue?vue&type=script&lang=ts"
export * from "./AlertMessage.vue?vue&type=script&lang=ts"

import "./AlertMessage.scss?vue&type=style&index=0&id=6bdf1935&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdf1935"]])

export default __exports__